<template>
  <v-footer class="py-4 px-5" color="black" height="auto">
    <v-container fluid mx-auto>
      <TkLogo v-if="$vuetify.breakpoint.xsOnly" :small="$vuetify.breakpoint.xsOnly" class="white--text my-auto pb-5" style="display: flex; justify-content: center"/>
      <v-layout row wrap>
        <v-flex xs12 sm3 class="mb-4">
          <h3>{{ $t('MENU.FOR_BUYERS')}}</h3>
          <hr />
          <ul>
            <!-- <li>
              <router-link to="/galleries">{{ $tc('MENU.GALLERY', 2) }}</router-link>
            </li>-->
            <li>
              <router-link to="/search">{{ $t('MENU.SEARCH_ART') }}</router-link>
            </li>

            <li>
              <router-link to="/giftcard">{{ $t('MENU.GIFT_CARD') }}</router-link>
            </li>

            <li>
              <router-link to="/newsletter">{{ $t('COMMON.NEWSLETTER_SUBSCRIBE') }}</router-link>
            </li>

            <li>
              <router-link to="/news">{{ $t('MENU.NEWS') }}</router-link>
            </li>

            <li>
              <router-link to="/customer-feedback">{{ $t('MENU.BUYER_FEEDBACK') }}</router-link>
            </li>

            <li>
              <router-link to="/taikos-catalogues">{{ $t('MENU.CATALOGUES') }}</router-link>
            </li>

            <li>
              <router-link to="/artists">{{ $tc('COMMON.ARTIST', 2) }}</router-link>
            </li>

            <li>
              <router-link to="/commission">{{ $t('MENU.COMMISSION') }}</router-link>
            </li>

            <li>
              <router-link to="/signup">{{ $t('MENU.REGISTER') }}</router-link>
            </li>

            <li>
              <router-link to="/supportartist">{{ $t('MENU.SUPPORT_ARTIST') }}</router-link>
            </li>

            <li>
              <router-link to="/companies">{{ $t('MENU.FOR_COMPANIES') }}</router-link>
            </li>

            <li>
              <router-link to="/whybuy">{{ $t('MENU.WHYBUY') }}</router-link>
            </li>

            <li>
              <router-link to="/buyersfaq">{{ $t('MENU.FAQ_FOR_BUYERS') }}</router-link>
            </li>

            <li>
              <router-link to="/abc">{{ $t('MENU.ABC') }}</router-link>
            </li>

            <!--  <li>
              <router-link to="/galleries">{{ $tc('MENU.GALLERY', 2) }}</router-link>
            </li>-->

            <li>
              <router-link to="/payment">{{ $t('MENU.PAYMENT') }}</router-link>
            </li>
            <li>
              <router-link to="/delivery">{{ $t('MENU.DELIVERY') }}</router-link>
            </li>
            <li>
              <router-link to="/returns">{{ $t('MENU.RETURN_POLICY') }}</router-link>
            </li>
            <!--            <li>-->
            <!--              <router-link to="/giftcardinfo">{{ $t('MENU.GIFT_CARDS') }}</router-link>-->
            <!--            </li>-->
            <li>
              <router-link to="/aland">{{ $t('MENU.ALAND') }}</router-link>
            </li>

          </ul>
        </v-flex>

        <v-flex xs12 sm9 class="mb-4 tk-footer__right">
          <NewsletterForm/>
          <v-spacer/>
          <v-layout row wrap class="tk-footer__right__items">
            <v-flex xs12 sm4 class="mb-4">
              <h3>{{ $t('MENU.FOR_ARTISTS')}}</h3>
              <hr />
              <ul>
                <li>
                  <router-link to="/artistguide">{{ $t('MENU.ARTISTS_GUIDE') }}</router-link>
                </li>
                <li>
                  <router-link to="/artistfaq">{{ $t('MENU.FAQ_FOR_ARTISTS') }}</router-link>
                </li>
                <li>
                  <router-link to="/newsletter">{{ $t('MENU.NEWSLETTER') }}</router-link>
                </li>
                <li>
                  <router-link to="/signup">{{ $t('MENU.ARTIST_SIGNUP') }}</router-link>
                </li>
              </ul>
            </v-flex>

            <v-flex xs12 sm4 class="mb-4">
              <h3>Taiko</h3>
              <hr />
              <ul>
                <li>
                  <router-link to="/about">{{ $t('MENU.ABOUT_TAIKO') }}</router-link>
                </li>
                <li>
                  <router-link to="/company">{{ $t('MENU.COMPANY') }}</router-link>
                </li>

                <!--             <li>
                              <router-link to="/media">{{ $t('MENU.MEDIA') }}</router-link>
                </li>-->
                <!--             <li>
                              <router-link to="/advertiser">{{ $t('MENU.FOR_ADVERTISERS') }}</router-link>
                </li>-->
                <li>
                  <router-link to="/contact">{{ $t('MENU.CONTACT') }}</router-link>
                </li>
                <li>
                  <router-link to="/termsconditions">{{ $t('MENU.TERMS') }}</router-link>
                </li>
                <li>
                  <router-link to="/about-this-site">{{ $t('MENU.ABOUT_SITE') }}</router-link>
                </li>
                <li>
                  <a href="javascript:void 0" onclick="ch2_showBanner(); setTimeout(function (){window.cookiehub.openSettings()},0);">{{ $t('MENU.COOKIE_SETTINGS') }}</a>
                </li>
              </ul>
            </v-flex>

            <v-flex xs12 sm4 class="mb-4">
              <h3>&nbsp;</h3>
              <hr />
              <ul>
                <li>{{ $t('MENU.CONTACT_H1') }}</li>
                <li>
                  <a :href="'mailto:' + email">{{ email }}</a>
                </li>
                <li>{{ $t('MENU.CONTACT_H2') }}</li>
                <li>
                  <a :href="'mailto:' + support">{{ support }}</a>
                </li>
                <li>
                  <a :href="'tel:' + phone">{{ phone }}</a>
                </li>
              </ul>
              <div class="pt-3">
                <tk-btn
                  flat
                  class="social-icon"
                  :href="fbLink"
                  rel="noreferrer"
                  target="_blank"
                  aria-label="facebook"
                >
                  <v-icon>fab fa-facebook-f</v-icon>
                </tk-btn>

                <tk-btn
                  flat
                  class="social-icon"
                  href="https://www.instagram.com/taiko.art/"
                  rel="noreferrer"
                  target="_blank"
                  aria-label="instagram"
                >
                  <v-icon>fab fa-instagram</v-icon>
                </tk-btn>

                <tk-btn
                  flat
                  class="social-icon"
                  href="https://www.youtube.com/channel/UCbhuSCr58pVFQ9Qm7-FzXUg"
                  rel="noreferrer"
                  target="_blank"
                  aria-label="youtube"
                >
                  <v-icon>fab fa-youtube</v-icon>
                </tk-btn>

                <tk-btn
                  flat
                  class="social-icon"
                  rel="noreferrer"
                  href="https://www.linkedin.com/company/taikoart"
                  target="_blank"
                  aria-label="linkedin"
                >
                  <v-icon>fab fa-linkedin-in</v-icon>
                </tk-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12>
          <tk-payment-options class="mt-2" />
        </v-flex>
      </v-layout>
      <div class="subheading text-xs-center mt-4">Copyright TAIKO {{ new Date().getFullYear() }}</div>
    </v-container>
  </v-footer>
</template>

<script>
import { companyPhone, companyEmail, supportEmail } from "@/config";
import TkPaymentOptions from "@/components/core/TkPaymentOptions";
import NewsletterForm from '../Domain/Newsletter/NewsletterForm'
import TkLogo from "@/components/core/TkLogo.vue";

export default {
  components: {
    TkLogo,
    NewsletterForm,
    TkPaymentOptions,
  },
  computed: {
    phone: () => companyPhone,
    email: () => companyEmail,
    support: () => supportEmail,
    fbLink() {
      const page =
        this.$i18n.locale === "fi" ? "taiko.fi" : "taikointernational";
      return `https://www.facebook.com/${page}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.tk-footer__right{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.tk-footer__right__items{
  flex: 0!important;
  margin-bottom: -24px;
}

.v-footer,
a {
  color: #ffffff !important;
}
hr {
  margin: 4px 36px 8px 0px;
  color: #979797;
}

ul {
  list-style-type: none;
  padding: 0px;
  margin-left: 16px;

  li {
    a {
      text-decoration: none;
      color: #ffffff;
      display: inline-block;
      min-width: 48px;
      padding: 4px;

      @media only screen and (max-width: 600px) {
        font-size: 1.2rem;
        line-height: 38px;
      }

      &:hover {
        opacity: 0.8;
      }
    }
  }
}
</style>
